import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ImageWithSource} from '../../models/floor-plan-editor-view';

@Component({
  selector: 'awair-image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.scss']
})

export class ImageUploaderComponent implements OnInit {

  @Input() hasDeviceMarkers: boolean = false;
  @Output() fileUpload: EventEmitter<ImageWithSource> = new EventEmitter<ImageWithSource>();

  constructor() {
  }

  ngOnInit() {
  }

  onClick(Event: Event, hasDeviceMarkers: boolean): void {
    if (hasDeviceMarkers && !confirm('Reuploading floor plan image will remove all positioned devices.\nDo you want to proceed?')) {
      event.preventDefault();
    }
  }

  onFileUpload(event: EventTarget): void {
    const eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    const target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    const file: File = target.files[0];
    const fileReader: FileReader = new FileReader();
    fileReader.onloadend = (e: ProgressEvent) => {
      const loadedFileReader: FileReader = <FileReader>e.target;
      this.fileUpload.emit({
        file,
        source: loadedFileReader.result
      });
    };
    fileReader.readAsDataURL(file);
  }
}
